import { Box, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';

const PinInput = ({ length = 4, onComplete, onSetPinOutSide }) => {
  const [pin, setPin] = useState(new Array(length).fill(''));

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (value === '' || /^[0-9]$/.test(value)) {
      const newPin = [...pin];
      newPin[index] = value;
      setPin(newPin);

      // Focus next input
      if (value !== '' && index < length - 1) {
        document.getElementById(`pin-${index + 1}`).focus();
      }

      // Call onComplete if PIN is fully entered
      if (newPin.every((val) => val !== '') && onComplete) {
        onComplete(newPin.join(''));
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !pin[index] && index > 0) {
      const newPin = [...pin];
      newPin[index - 1] = '';
      setPin(newPin);
      document.getElementById(`pin-${index - 1}`).focus();
    }
  };

  useEffect(() => {
    if (onSetPinOutSide) {
      onSetPinOutSide(pin.join(''));
    }
  }, [pin, onSetPinOutSide]);

  return (
    <Box width={'full'} display={'flex'} justifyContent={'space-between'}>
      {pin.map((digit, index) => (
        <TextField
          key={index}
          id={`pin-${index}`}
          type="text"
          value={digit}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          maxLength="1"
          InputProps={{
            sx: {
              width: '44px',
              height: '44px',
              borderRadius: '12px',
            },
          }}
          inputProps={{
            style: { textAlign: 'center' },
          }}
        />
      ))}
    </Box>
  );
};

export default PinInput;
